import React from 'react';
import Sidebar from './sidebar/Sidebar';
import Header from './header/Header';
import BottomNav from './BottomNav';
import ContentBackground from './ContentBackground';

type DashboardLayoutProps = {
  children: React.ReactNode;
};

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-transparent">
      {/* Sidebar fixe */}
      <Sidebar className="hidden lg:flex lg:flex-col lg:fixed lg:inset-y-0 lg:left-0 lg:w-60 lg:z-50" />

      {/* Contenu principal avec marge gauche */}
      <div className="lg:ml-60 flex-1 min-h-screen flex flex-col bg-transparent bg-gradient-to-r from-white via-primary/5 to-primary/10">
        <ContentBackground />
        <Header />
        <main className="flex-1 pb-14 lg:pb-0 relative">
          <div className="container mx-auto px-4 py-4 lg:py-6 bg-transparent">
            {children}
          </div>
        </main>
      </div>
      <BottomNav />
    </div>
  );
};

export default DashboardLayout;